import CaretDownOutlined from '@ant-design/icons/CaretDownOutlined';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import Selection from './Selection';
import { useTranslation } from 'react-i18next';

const ToolbarSelection = ({
  bState,
  groupId,
  primary: _primary,
  items: _items,
  onInteraction,
  disabled,
}) => {
  const { t } = useTranslation('ViewerTool');
  const handleChange = (id) => {
    const item = _items.find((it) => it?.id === id);
    onInteraction({
      groupId,
      //
      itemId: item.id,
      // splitButtonId? (so we can track group?)
      // info to fire item's command/event?
      commands: item.commands,
    });
  };
  const selectedItem =
    _items.find((it) => it?.id == bState?.groups?.[groupId] && !!bState?.toggles?.[it?.id]) ||
    _primary;

  return (
    <div className="relative mx-1.5 flex">
      {/* <Tooltip title={_primary.tooltip} placement="top"> */}
      <Selection
        size="small"
        menuItemSelectedIcon={null}
        suffixIcon={<CaretDownOutlined className="text-sm" />}
        value={selectedItem?.id}
        onChange={handleChange}
        disabled={disabled}
        style={{ background: 'transparent' }}
        dropdownMatchSelectWidth={false}
      >
        {_items
          .filter((item) => !item.hidden)
          .map((it) => (
            <Select.Option key={it.id} value={it.id} disabled={it.hidden}>
              {t(it.label)}
            </Select.Option>
          ))}
      </Selection>
      {/* </Tooltip> */}
    </div>
  );
};

ToolbarSelection.defaultProps = {
  isRadio: false,
  isAction: false,
  primary: {
    label: null,
    tooltip: null,
  },
  secondary: {
    icon: 'chevron-down',
    label: null,
    isActive: true,
    tooltip: 'More Measure Tools',
  },
  items: [],
};

ToolbarSelection.propTypes = {
  primary: PropTypes.shape({
    id: PropTypes.string.isRequired,
    icon: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
  }),
  renderer: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.string,
      label: PropTypes.string,
      tooltip: PropTypes.string,
      isActive: PropTypes.bool,
    })
  ),
  /** Callback function to inform ToolBarService of important events */
  onInteraction: PropTypes.func.isRequired,
};

export default ToolbarSelection;
